var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/utils/cartdrawer.js
var cartDrawer = class {
  constructor() {
    __publicField(this, "handleOutsideClick", (event) => {
      if (event.target === this.curtain)
        this.close();
    });
    this.cartDrawerElement = document.querySelector("cart-drawer");
    this.curtain = document.querySelector("#curtain");
  }
  open() {
    const desktopRecommendations = document.querySelector("#desktop-recommendations");
    this.cartDrawerElement.setAttribute("aria-hidden", "false");
    this.curtain.setAttribute("aria-hidden", "false");
    this.curtain.addEventListener("click", this.handleOutsideClick);
    setTimeout(() => {
      desktopRecommendations.setAttribute("aria-hidden", "false");
      desktopRecommendations.style.visibility = "visible";
    }, 250);
  }
  close() {
    const desktopRecommendations = document.querySelector("#desktop-recommendations");
    desktopRecommendations.setAttribute("aria-hidden", "true");
    setTimeout(() => {
      this.cartDrawerElement.setAttribute("aria-hidden", "true");
      this.curtain.setAttribute("aria-hidden", "true");
      this.curtain.removeEventListener("click", this.handleOutsideClick);
      desktopRecommendations.style.visibility = "hidden";
    }, 250);
  }
};
var cartdrawer_default = new cartDrawer();

// src/utils/body-lock.js
var bodyLock = class {
  /**
   * lock the body to prevent scrolling.
   */
  lock() {
    const bodyElement = document.querySelector("body");
    console.log("locked");
    bodyElement.setAttribute("data-body-lock", "true");
  }
  /**
   * unlock the scrolling of the body.
   */
  unlock() {
    const bodyElement = document.querySelector("body");
    console.log("unlocked");
    bodyElement.setAttribute("data-body-lock", "false");
  }
};
var body_lock_default = new bodyLock();

// src/extenders/header-handler.js
var HeaderHandler = class extends HTMLElement {
  constructor() {
    super();
    const mobileNavToggle = this.querySelector("#js-mobile-navigation-toggle");
    const mobileSubNavTriggerOpen = document.querySelectorAll(".js-mobile-subnav-open");
    const mobileSubNavTriggerClose = document.querySelectorAll(".js-mobile-subnav-close");
    const cartToggle = this.querySelector("#cart-opener");
    cartToggle.addEventListener("click", () => {
      cartdrawer_default.open();
    });
    const handleMenuVisibility = (id) => {
      const childMenus = document.querySelectorAll(".js-subnav");
      childMenus.forEach((menu) => {
        if (menu.getAttribute("data-handle") === id) {
          menu.classList.add("block");
          menu.classList.remove("hidden");
        } else {
          menu.classList.add("hidden");
          menu.classList.remove("block");
        }
      });
    };
    mobileSubNavTriggerOpen.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        handleMenuVisibility(trigger.getAttribute("id"));
        toggleMobileSubNav();
      });
    });
    mobileSubNavTriggerClose.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        toggleMobileSubNav();
      });
    });
    const toggleMobileNavVisibility = () => {
      const mobileNav = document.querySelector("#mobile-navigation-modal");
      if (mobileNav.getAttribute("aria-expanded") === "true") {
        mobileNav.setAttribute("aria-expanded", "false");
        body_lock_default.unlock();
      } else {
        mobileNav.setAttribute("aria-expanded", "true");
        body_lock_default.lock();
      }
    };
    const toggleAriaExpandedHandler = () => {
      const mobileNavHandler = this.querySelector("#js-mobile-navigation-toggle");
      if (mobileNavHandler.getAttribute("aria-expanded") === "true") {
        mobileNavHandler.setAttribute("aria-expanded", "false");
      } else {
        mobileNavHandler.setAttribute("aria-expanded", "true");
      }
    };
    mobileNavToggle.addEventListener("click", () => {
      toggleMobileNavVisibility();
      toggleAriaExpandedHandler();
    });
    const toggleMobileSubNav = () => {
      const mobileSubNav = document.querySelector("#mobile-subnav");
      if (mobileSubNav.getAttribute("aria-expanded") === "true") {
        mobileSubNav.setAttribute("aria-expanded", "false");
      } else {
        mobileSubNav.setAttribute("aria-expanded", "true");
      }
    };
  }
};
if (customElements.get("header-handler") === void 0) {
  customElements.define("header-handler", HeaderHandler);
}
